/* Horizontal shelf paging.
 *
 * Two behaviours worth taking from Instacart's own ScrollTrack: the arrows are computed away when
 * the track already fits — an affordance that cannot do anything is not rendered — and a page is
 * one viewport MINUS an overlap, so the shopper keeps a visual anchor across the jump instead of
 * landing on an unfamiliar row.
 *
 * Direction-agnostic: in RTL, scrollLeft runs negative in this engine and positive in others, so
 * the code works in the element's own inline axis rather than assuming a sign.
 */
const OVERLAP = 64

function bindShelves(root = document) {
  for (const nav of root.querySelectorAll('[data-shelf-nav]')) {
    if (nav.dataset.bound) continue
    nav.dataset.bound = '1'
    const shelf = nav.closest('.shelf')
    const track = shelf?.querySelector('.shelf__scroll')
    if (!track) continue

    const prev = nav.querySelector('[data-shelf-prev]')
    const next = nav.querySelector('[data-shelf-next]')

    const update = () => {
      const overflowing = track.scrollWidth - track.clientWidth > 2
      nav.toggleAttribute('data-scrollable', overflowing)
      if (!overflowing) return
      // Normalised 0..1 position, so the same maths holds whichever way the axis runs.
      const max = track.scrollWidth - track.clientWidth
      const pos = Math.abs(track.scrollLeft)
      prev.disabled = pos < 2
      next.disabled = pos > max - 2
    }

    const page = (dir) => {
      const step = Math.max(track.clientWidth - OVERLAP, 120)
      // `inline` respects the writing direction; a raw scrollLeft delta would page the wrong way in RTL.
      track.scrollBy({ left: dir * step * (getComputedStyle(track).direction === 'rtl' ? -1 : 1), behavior: 'smooth' })
    }

    prev.addEventListener('click', () => page(-1))
    next.addEventListener('click', () => page(1))
    track.addEventListener('scroll', update, { passive: true })
    new ResizeObserver(update).observe(track)
    update()
  }
}
bindShelves()
/* Recommendation shelves and quick-view content arrive after this module runs, so binding has to be
   repeatable rather than a one-shot pass at load. */
document.addEventListener('opensku:shelves-added', () => bindShelves())
